<template>
  <div class="tree_table_item" :style="{'width':data.width}" v-if="data">
    <template v-if="data.score == 999">
      <div style="text-align:center;">未开通权限</div>
    </template>
    <template v-else>
       <template v-if="data.type == 1">
      <div class="score_and_total_score" v-if="data.score>-1">
        <span class="score">{{ data.score }}</span
        ><span style="total_score" v-if="data.total_score>0"
          >/{{ data.total_score }}</span
        >分
      </div>
    </template>
    <template v-else-if="data.type == 2">
      <div class="tree_table_score_box">
        <div class="tree_table_score">
          <span class="tree_table_score_attr"> 得分: </span>
          <span class="tree_table_score_val" v-if="data.score>-1 && data.total_score>-1">
            <span style="color:#e46c6c">{{ data.score }}</span>/{{ data.total_score }}分
          </span>
        </div>
        <div class="tree_table_percent" v-if="data.score>-1 && data.total_score>-1">
          {{ ((data.score / data.total_score) * 100).toFixed(2) }}%
        </div>
      </div>
      <el-progress
        v-if="data.score>-1 && data.total_score>-1"
        :stroke-width="15"
        :show-text="false"
        :percentage="((data.score / data.total_score) * 100).toFixed(2)"
        color="#1FBCBF"
      >
      </el-progress>
    </template>
    <template v-else-if="data.type == 3">
      <div class="tree_table_score_box">
        <div class="tree_table_score">
          <span class="tree_table_score_attr"> 得分: </span>
          <span class="tree_table_score_val" v-if="data.score>-1"> {{ data.score }}分 </span>
        </div>
        <div class="tree_table_percent"></div>
      </div>
      <el-progress
        v-if="data.score>-1 && data.total_score>-1"
        :stroke-width="15"
        :show-text="false"
        :percentage="((data.score / data.total_score) * 100).toFixed(2)"
        color="#1FBCBF"
      >
      </el-progress>
    </template>
    <template v-else-if="data.type == 4">
      <div class="tree_table_score_val_2" v-if="data.score>-1">{{ data.score }}分</div>
    </template>
    </template>
   
  </div>
</template>

<script>
import { ElProgress } from "element-plus";

export default {
  name: "TreeTableItem",
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  components: {
    ElProgress,
  },
};
</script>

<style lang="less" scoped>
.tree_table_item {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  .tree_table_score_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tree_table_score {
      font-size: 12px;
      line-height: 20px;
      .tree_table_score_attr {
        color: #8791b2;
      }
      .tree_table_score_val {
        color: #474747;
      }
    }
    .tree_table_percent {
      font-size: 12px;
      color: #474747;
      line-height: 20px;
    }
  }
  .tree_table_score_val_2 {
    text-align: center;
    font-size: 16px;
    color: #e7816e;
  }
  .score_and_total_score {
    display: flex;
    justify-content: center;
    .score {
      color: #e7816e;
    }
  }
}

:deep(.el-progress) {
  height: 4px;
  .el-progress-bar {
    height: 4px;
    .el-progress-bar__outer {
      height: 4px !important;
      background: #efefef;
      border: 1px solid #e0e0e0;
    }
  }
}
</style>